import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';

import { actualStartDate } from './actual-start-date';


const fieldId = 'actual_end_date';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;
  const value = values[fieldId];

  // define thisMoment (end date) to check if it's before startMoment (the start date)
  const thisMoment = moment.tz(value, DEFAULT_TIMEZONE).startOf('minute');
  const startMoment = moment.tz(values[actualStartDate.id], DEFAULT_TIMEZONE).startOf('minute');

  // figure out the differences between thisMoment and startMoment
  const timeDiffMinutes = thisMoment.diff(startMoment, 'minutes');


  // define the differences in time that are no acceptable
  const maxMinutesDiff = 30;

  // ie, 1:00 -> 1:29 === error but 1:00 -> 1:30 is fine!
  const lessThanMaxMinutesDiff = timeDiffMinutes < maxMinutesDiff;



  // const { minDate, maxDate } = field.componentData.vFParams;
  // const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  // const dateIsAfterMax = commonValidation.date.isAfterMaxDate(value, maxDate);


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter Actual start and end date/time.' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? <FieldWarningError /> : null);

  errors[INLINE_ERRORS].push(lessThanMaxMinutesDiff ? 'End date/time must be at least 30mins after the start date/time' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Actual end date/time',
  displayType: 'small',
};

const actualEndDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { actualEndDate };
